/**
 * @deprecated - auth0 will not have a session id: we will use JWT authentication token instead
 */
export const selectSessionId = state => state?.authentication?.sessionId;
